/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";
import { Fade } from "react-awesome-reveal";

const WorkingProcess = () => {
  const steps = [
    {
      number: "01",
      title: "Consultation",
      description:
        "We take the time to understand your business goals and challenges.",
      icon: (
        <svg
          className="w-8 h-8 text-teal-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2z"
          />
        </svg>
      ),
    },
    {
      number: "02",
      title: "Strategy",
      description:
        "Together, we create a customized investment plan tailored to your needs.",
      icon: (
        <svg
          className="w-8 h-8 text-teal-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    {
      number: "03",
      title: "Investment",
      description:
        "We provide the necessary capital and resources to fuel your growth.",
      icon: (
        <svg
          className="w-8 h-8 text-teal-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    {
      number: "04",
      title: "Support",
      description:
        "Our team offers continuous guidance to ensure sustained success and reliability.",
      icon: (
        <svg
          className="w-8 h-8 text-teal-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="container px-6 py-16 mx-auto ">
      <Fade bottom triggerOnce>
        <h2 className="mb-4 text-4xl font-bold text-center text-gray-800">
          Our Working Process
        </h2>
        <p className="mb-12 text-center text-gray-500">
          4 easy steps to get the best results
        </p>
      </Fade>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
        {steps.map((step) => (
          <div key={step.number} className="text-center">
            <div className="flex justify-center mb-4">
              <div className="relative">
                <div className="flex items-center justify-center w-16 h-16 bg-teal-100 rounded-full">
                  {step.icon}
                </div>
                <span className="absolute flex items-center justify-center w-6 h-6 text-xs font-semibold text-white bg-teal-500 rounded-full -top-2 -left-2">
                  {step.number}
                </span>
              </div>
            </div>
            <h3 className="mb-2 text-lg font-semibold text-gray-700">
              {step.title}
            </h3>
            <p className="text-gray-600">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkingProcess;
